import { ErrorDialog } from "src/components/common/dialogs/errorDialog/ErrorDialog.tsx";
import { useErrorDialog } from "src/components/common/dialogs/errorDialog/ErrorDialogContext.tsx";

export const ErrorDialogHost = () => {
	const { closeErrorDialog, currentError, disableCustomizedErrorViews } = useErrorDialog();
	if (currentError == null) return null;

	return (
		<ErrorDialog
			size={"sm"}
			closeDialog={closeErrorDialog}
			error={currentError}
			disableCustomizedErrorViews={disableCustomizedErrorViews}
		/>
	);
};
